import axiosInstance from "../../../http-common";
import { v4 } from "uuid";
import { logout_if_403 } from "../../../util";

export const getErrorMessage = (error) => {
  if (error instanceof Error) return error.message;
  return String(error);
};
export const load_approver_data_from_backend = async (
  data,
  setData,
  tabName
) => {
  // console.log("loading po from backend");
  try {
    const result = await axiosInstance.get(`v1/qc/backlog_po/${tabName}?role=approver`);
    // console.log(result);
    if (result.data) {
      // const tableData = result?.data?.data?.map((item) => ({
      //   ...item,
      //   id: v4(),
      // }));
      const tableData = result.data?.data
        ?.filter((item) => item.remark === "Awaiting Approval")
        .map((item) => ({ ...item, id: v4() }));
      // console.log(tableData);
      if (
        result["data"]?.["data"] &&
        setData &&
        typeof setData === "function"
      ) {
        setData(tableData);
      }
    }
  } catch (error) {
    logout_if_403(error);
    console.error(getErrorMessage(error));
  }
};
